import React from 'react';
import Layout from '../components/layout';
import Header from '../components/header';
import Footer from '../components/footer';
import Contact from '../components/Contact';
import Seo from '../components/seo';
import { usePageMetadata } from '../hooks/usePageMetadata';

const ContactPage = () => {
    usePageMetadata({
        title: 'Contact Us - Bercastle',
        description: 'Get in touch with Bercastle. We are ready to help you build the future.',
        pageType: 'contact',
        content: {
            page: {
                name: "Contact Us",
                tagline: "Get in Touch",
                description: "Ready to build the future with AI? Get in touch with our team today."
            },
            company: {
                name: "Bercastle",
                email: "hello@bercastle.com",
                location: "Croatia, Europe"
            },
            services_offered: [
                "AI Development",
                "Machine Learning",
                "Web & Mobile Development",
                "Cloud Solutions",
                "Digital Transformation",
                "Business Intelligence"
            ],
            process: [
                "Quick Response: We respond within 24 hours",
                "Free Consultation: Initial discussion at no cost",
                "Custom Proposal: Tailored solution for your needs",
                "Clear Timeline: Realistic project estimates"
            ],
            meta: {
                source_url: "https://bercastle.com/contact",
                page_type: "contact"
            }
        }
    });

    return (
        <Layout classmain="contact-page">
            <Seo
                title='Contact Us - Bercastle'
                metaDesciption='Get in touch with Bercastle. We are ready to help you build the future.'
            />
            <Header />
            <div className="pt-20"> {/* Add padding top to account for fixed header if needed, or just spacing */}
                <Contact />
            </div>
            <Footer />
        </Layout>
    );
};

export default ContactPage;
